import { Component, HostBinding, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AppService } from '../../../../services/app.service';
import { RoleSearchRequest } from '../../../../models/net/request/role-search-request';
import { Role } from '../../../../models/data/identity/role';
import { RoleService } from '../../../../services/identity/roles/role.service';
import { SearchComponent } from '../../../base/search/search.component';
import { SearchRequestTypeEnum } from '../../../../enums/search-request-type-enum';
import { SearchMarqueeComponent } from '../../../fragments/search-marquee/search-marquee.component';
import { SearchRequestEnvelope } from '../../../../models/net/envelope/search-request-envelope';
import { SearchPreference } from '../../../../models/data/app-core/search-preference';
import { SessionService } from '../../../../services/session/session.service';

@Component({
    selector: 'app-roles',
    templateUrl: './roles.component.html',
    styleUrls: ['./roles.component.css', '../../../../app.component.css']
})

export class RolesComponent extends SearchComponent implements OnInit {

    public displayedColumns: string[] = ["Avatar", "RoleUID", "Delete"];
    public override searchRequest: RoleSearchRequest = new RoleSearchRequest();
    public override searchResult: Role[] = [];
    //public searchRequestTypeEnum: SearchRequestTypeEnum = SearchRequestTypeEnum.RoleSearchRequest;
    public searchRequestTypeName: string = "SearchRequestEnvelope";
    public searchRequestTileComponentTypeName: string = "SearchTileComponent";

    @ViewChild("searchMarquee") searchMarquee!: SearchMarqueeComponent;

    public constructor(public override appService: AppService, public override sessionService: SessionService, public override itemService: RoleService) {

        super(appService, sessionService, itemService, "role", "Role");
        super.searchRequestTypeEnum = SearchRequestTypeEnum.RoleSearchRequest;
    }

    public ngAfterViewInit(): void {

        this.searchMarquee!.runSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            const searchRequest: RoleSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            this.runSearch(searchRequest);
        });

        this.searchMarquee!.runSavedSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            var searchRequest: RoleSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            if (searchRequest) {

                this.runSearch(searchRequest);
            }
        });
    }

    public override handleSearchPreference(searchPreference: SearchPreference): void {

        if (searchPreference.SearchPreferenceId > 0) {

            if (searchPreference.DefaultSearchRequestId) {

                this.searchMarquee!.isSavedSearchMode = true;

                this.searchMarquee!.setDefaultSearchRequestId(searchPreference.DefaultSearchRequestId);

                if (searchPreference.IsRunDefaultSearchOnLoad) {

                    this.searchMarquee!.searchRequested();
                }
            }

        } else {

            this.searchMarquee!.isSavedSearchMode = false;
        }

        this.isSearchMarqueeDisabled = false;
    }

    public override getItemIndexFromSearchResult = (id: number): number | undefined => {

        const result = this.searchResult.map((i: Role) => i.RoleId).indexOf(id, 0);

        return result;
    }

    public runSearch = (searchRequest: RoleSearchRequest): void => {

        this.searchRequest = searchRequest;

        this.search();
    }
}
